<template>
  <div class="wrap">
    <div class="task-wrap">
      <div class="task-top">
        <div class="task-top-left">
          <div>任务</div>
          <RadioGroup v-model="filterQuery.progress" type="button" style="margin-left: 8px" @on-change="loadTask(0)">
            <Radio label="all">全部</Radio>
            <Radio label="created">未完成</Radio>
          </RadioGroup>
        </div>
        <Button type="primary" @click="showNewTask = true">创建</Button>
      </div>
      <div class="new-task-area" v-if="showNewTask">
          <div class="new-task-input-area">
            <div style="width: 120px">新任务：</div>

            <Select v-model="newTask.mainResponsible" filterable style="width: 170px">
                <Option v-for="user in simpleUserList" :value="user._id" :key="user._id">{{ user.name }}</Option>
            </Select>
            
            <Input
              ref="input-title"
              v-model="newTask.title"
              placeholder="任务"
              @on-enter="createNewTask"
              ></Input>

            <Input
              ref="input-deadLine"
              style="width: 170px"
              v-model="newTask.deadLine"
              placeholder="截止时间"
              @on-enter="createNewTask"
              ></Input>
          </div>
          
          <div class="new-task-btn-area">
            <Button @click="createNewTask" size="small" type="primary">保存</Button>
            <Button @click="showNewTask = false" size="small">取消</Button>
          </div>
        </div>
      <div v-for="task in taskList">
        <TaskBox :task="task"/>
      </div>
    </div>
    <div class="comment-wrap">
      <div class="comment-top">
        <div style="margin-bottom: 16px">评论</div>
        <Input v-model="newComment.comment" type="textarea" placeholder="填写评论..." style="margin-bottom: 16px"/>
        <div style="display: flex;justify-content: end;">
          <Button type="primary" @click="createNewComment">发送</Button>
        </div>
      </div>
      <div class="comment-list-wrap">
        <div class="comment-page">
          <span>共{{ commentTotalCounts }}条</span>
          <Page
            :total="commentTotalCounts"
            :page-size="commentLimit"
            @on-change="loadComment"
            show-total
            simple
            style="margin-right: 24px"
          />
        </div>
        <div v-for="comment in commentList">
          <div class="comment-item">
            <div class="comment-item-top">
              <div class="comment-createdBy">{{comment.createdBy.name}}</div>
              <div class="comment-createdAt">{{comment.createdAt}}</div>
            </div>
            <div class="comment">{{comment.comment}}</div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import TaskBox from "@/views/TaskPage/TaskBox.vue";
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";

export default {
  name: 'CustomerCommentPanel',
  components: {
    TaskBox,
  },
  props: {
    customer: {
      type: Object
    }
  },
  data() {
    return {
      filterQuery: {
        progress: 'all',
      },
      page: 0,
      limit: 50,
      showNewTask: false,
      newTask: {
        mainResponsible: null,
        title: '',
        deadLine: null,
      },
      commentPage: 0,
      commentLimit: 20,
      commentFilterQuery: {
      },
      newComment: {
        comment: '',
      },
    };
  },
  watch: {
    customer:async function(n) {
      if (this.customer.customer._id) {
        await this.loadTask()
        await this.loadComment()
      }
    },
  },
  computed: mapState({
    taskList: (state) => state.task.taskList,
    simpleUserList: (state) => state.user.simpleUserList,
    commentList: (state) => state.comment.commentList,
    commentTotalCounts: (state) => state.comment.totalCounts,
  }),
  methods: {
    ...mapActions({
      getTaskList: "task/getTaskListAction",
      getSimpleUserList: "user/getSimpleUserListAction",
      createTask: "task/createTaskAction",
      getComments: "comment/getCommentsAction",
      createComment: "comment/createCommentAction",
    }),
    async loadTask(page) {
      if (page) this.page = page - 1;
      const query = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
        customer: this.customer.customer._id
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      if (query.progress === 'all') delete query.progress;
      try {
        await this.getTaskList(query);
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
      }
    },
    async createNewTask() {
      if (this.newTask.title.trim() === '') {
        return this.$Message.info('不能创建空白任务')
      }
      const newTaskData = {
        title: this.newTask.title,
        type: 'custom'
      }
      if (this.newTask.mainResponsible) {
        newTaskData.mainResponsible = this.newTask.mainResponsible;
      }
      
      if (this.newTask.deadLine) {
        const dlText = this.newTask.deadLine.trim();
        if (dayjs(dlText).isValid()) {
          newTaskData.deadLine = dayjs(dlText);
          if (newTaskData.deadLine.year() === 2001) {
            const currentYear = dayjs().year();
            newTaskData.deadLine = dayjs(dlText).year(currentYear);
          }
        } else {
          console.log('invalid date');
        }
      }
      newTaskData.customer = this.customer.customer._id
      await this.createTask(newTaskData);
      this.newTask = {
        mainResponsible: null,
        title: '',
        deadLine: null,
      }
      this.$Message.success('创建成功')
    },

    async loadComment(page) {
      if (page) this.commentPage = page - 1;
      const query = {
        ...this.commentFilterQuery,
        limit: this.commentLimit,
        skip: this.commentPage * this.commentLimit,
        customer: this.customer.customer._id
      }
      await this.getComments(query)
      this.commentList.map(x=> x.createdAt = dayjs(x.createdAt).format('YYYY-M-D H:m'))
    },
    async createNewComment() {
      if (this.newComment.comment.trim() === '') {
        return this.$Message.info('内容不能为空')
      }
      const newCommentData = {
        comment: this.newComment.comment,
      }
      newCommentData.customer = this.customer.customer._id
      await this.createComment(newCommentData)
      this.newCommentData.comment = null
      this.$Message.success('评论成功')
    },
  },
  async created() {
    // window.addEventListener('keydown', this.keyDownHandler)
    this.showNewTask = false
    await this.getSimpleUserList({ limit: 999 });
  },
  mounted() {
    this.showNewTask = false
    this.newTask = {
      mainResponsible: null,
      title: '',
      deadLine: null,
    }
  },
};
</script>
<style lang="stylus" scoped>
.task-wrap
  margin-bottom 20px
  
.task-top
  display flex
  justify-content space-between
  margin-bottom 16px
  .task-top-left
    display flex
    align-items center

.new-task-area
  background-color #ececec
  padding 8px
  margin-bottom 12px
  border-radius 4px
.new-task-input-area
  margin 8px
  display flex
  gap 8px
  align-items center

.new-task-btn-area
  margin 8px
  display flex
  gap 8px
  justify-content flex-end

.comment-top
  margin-bottom 16px

.comment-list-wrap
  height 800px
.comment-page
  display flex
  margin-bottom 16px
.comment-item
  border 1px solid
  padding 6px
  .comment-item-top
    display flex
    align-items center
    margin-bottom 8px
    .comment-createdBy
      margin-right 16px
      font-size 20px
</style>